import { Container } from "inversify";
import { TYPES } from "./types";
import {
  EmploymentService,
  EmploymentHttpClient,
} from "./services/EmploymentService";
import {
  IEmploymentHttpClient,
  IEmploymentService,
} from "./interfaces/IEmploymentService";
import { JobPositionResource } from "./services/JobPositionResource";
import { ContainerResource } from "./services/ContainerResource";
import { IJobPositionResource } from "./interfaces/IJobPositionResource";
import { IContainerResource } from "./interfaces/IContainerResource";
import { SignalRBuilder } from "./models/signalr/SignalRBuilder";
import { ISignalRService } from "./interfaces/ISignalR";
import { useStore } from "vuex";
const store = useStore();

const myContainer = new Container();

myContainer
  .bind<ISignalRService>(TYPES.ISignalRService)
  .toDynamicValue(() => {
    return new SignalRBuilder();
  })
  .inSingletonScope();

myContainer
  .bind<IEmploymentHttpClient>(TYPES.IEmploymentHttpClient)
  .to(EmploymentHttpClient);

myContainer
  .bind<IJobPositionResource>(TYPES.IJobPositionResource)
  .toDynamicValue(() => {
    const client = myContainer.get<IEmploymentHttpClient>(
      TYPES.IEmploymentHttpClient
    );
    return new JobPositionResource(client);
  });
myContainer
  .bind<IContainerResource>(TYPES.IContainerResource)
  .toDynamicValue(() => {
    const client = myContainer.get<IEmploymentHttpClient>(
      TYPES.IEmploymentHttpClient
    );
    return new ContainerResource(client);
  });
myContainer
  .bind<IEmploymentService>(TYPES.IEmploymentService)
  .toDynamicValue((context) => {
    const httpClient = context.container.get<IEmploymentHttpClient>(
      TYPES.IEmploymentHttpClient
    );
    const conainerResource = myContainer.get<IContainerResource>(
      TYPES.IContainerResource
    );
    const positionResource = myContainer.get<IJobPositionResource>(
      TYPES.IJobPositionResource
    );
    return new EmploymentService(
      positionResource,
      conainerResource,
      httpClient
    );
  });
export { myContainer };
